<template>
    <div class="row mt-4">
        <div class="col-md-12">
            <h2 class="mb-4">History</h2>
        </div>
        <div class="col-md-1 offset-md-11 text-right">
            <select class="custom-select" id="results_count" name="results_count" v-model="count" v-on:change="load">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="0">ALL</option>
            </select> 
        </div>
        <div class="col-md-12 mt-4">
            <table class="table table-hover table-responsive-md">
                <thead>
                    <tr><th scope="col">Date</th> <th scope="col">Time</th> <th scope="col">Type</th> <th scope="col">Username</th> <th scope="col">Fields Changed</th> <th scope="col">Risk Rating</th> <th class="actions-col" scope="col">Actions</th></tr>
                </thead> 
                <tbody>
                    <tr v-for="log in history" :key="log.id">
                        <td scope="row" class="text-nowrap">{{ log.date }}</td>
                        <td scope="row" class="text-nowrap">{{ log.time }}</td>
                        <td scope="row">{{ formatEventField(log.new_values) }}</td>
                        <td scope="row">{{ log.user.username }}</td>
                        <td scope="row">{{ fieldsChangedMessage(log.fields_changed) }} </td>
                        <td scope="row">{{ displayRiskRating(log.new_values) }}</td>
                        <td class="actions-col text-nowrap" scope="row">
                            <div class="btn-group">
                                <router-link :to="{name:'history.view', params:{retailerId: id, id: log.id}}" v-tooltip="'Details'" class="btn btn-default py-0 px-1">
                                    <img src="../../assets/svgs/Details-Icon.svg">
                                </router-link>
                                <router-link v-if="log.new_values.last_visit_id" :to="{name: 'visits.edit', params: {id: log.new_values.last_visit_id, retailerId: id}}" v-tooltip="'View Visit'" class="btn btn-default py-0 px-1">
                                    <img src="../../assets/svgs/Visit-Icon.svg">
                                </router-link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="12" class="text-center" v-if="history.length == 0">
                            No Results Found
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination :data="paginator" :limit="2" align="right" @pagination-change-page="load"></pagination>
        </div>
    </div>
</template>

<script>
import RetailerHistoryService from "../../services/RetailerHistoryService";
import CurrentUser from "../../mixins/CurrentUser";
import pagination from "laravel-vue-pagination";

export default {
    data: function () {
        return {
            loading: false,
            history: {},
            paginator: {},
            count: 5,
        }
    },

    mixins:[CurrentUser],

    components: {
        pagination
    },

    props: {
        id: {
            default: null,
        },
    },

    mounted() {
        this.load();
    },

    watch: {
        id: function () {
            this.load();  
        },
    },

    methods: {

        load: function (page = 1) {
            this.loading = true;
            let params = {
                id: this.id,
                page: page,
                count: this.count
            }
            RetailerHistoryService.all(params)
                .then( ({data}) => {
                    this.history = data.data;
                    this.paginator = data.meta;
                    this.loading = false;
                });
        },

        fieldsChangedMessage: function (fieldCount) {
            return fieldCount == 1 ? fieldCount + ' field changed.' : fieldCount + ' fields changed.';
        },

        displayRiskRating: function (newValues) {
            if("risk_rating" in newValues) {
                return 'Updated to ' + newValues.risk_rating;
            }
            return '';
        },

        formatEventField: function (newValues) {
            if("last_visit_id" in newValues) {
                return 'Visit';
            } else {
                return 'Updated';
            }
        }
    }
}
</script>